import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-b09b7604"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "offers-container"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  key: 0,
  class: "no-offers"
};
var _hoisted_4 = {
  "data-cy": "no-offers-text"
};
var _hoisted_5 = {
  class: "offer-info"
};
var _hoisted_6 = {
  class: "offer-title"
};
var _hoisted_7 = {
  class: "offer-discount"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "red",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [/*#__PURE__*/_createElementVNode("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }), /*#__PURE__*/_createElementVNode("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  })], -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");

  var _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("offers.offers")), 1), _ctx.offers.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("offers.no-pending")), 1)])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offers, function (offer, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "offer-item"
    }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(offer.priceName), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(offer.title) + " " + _toDisplayString(offer.discount) + "% ", 1)]), _createVNode(_component_el_input, {
      modelValue: offer.amount,
      "onUpdate:modelValue": function onUpdateModelValue($event) {
        return offer.amount = $event;
      },
      class: "offer-price",
      size: "default",
      disabled: ""
    }, {
      prepend: _withCtx(function () {
        return [_createTextVNode(_toDisplayString(_ctx.bookingCurrency), 1)];
      }),
      _: 2
    }, 1032, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_button, {
      circle: "",
      size: "small",
      class: "remove-btn",
      onClick: function onClick($event) {
        return _ctx.confirmRemovingOffer(offer);
      },
      disabled: !offer.stillPending,
      "data-cy": "offer-remove-btn"
    }, {
      default: _withCtx(function () {
        return [_hoisted_8];
      }),
      _: 2
    }, 1032, ["onClick", "disabled"])]);
  }), 128))]);
}